/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/circle-check-big
 */
import { default as DefaultIcon } from '~icons/lucide/circle-check-big';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const CircleCheckBigIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
